import AxiosClient from "../AxiosClient";

export const postCommodityOwnerInvoiceRegistrationHistorySearchInfoListAPI = (params) => {
  return AxiosClient.post("/api/commodityOwnerInvoiceRegistrationHistory/searchInfoList", params);
}